import './SeasonHistory.css';

const nf = new Intl.NumberFormat('en-GB');

const TOP_10K = 10_000;
const TOP_100K = 100_000;

/* Ranked best first, so a top-10k finish is not also labelled top-100k. */
const TIERS = [
	{ id: '10k', max: TOP_10K, label: 'Top 10k' },
	{ id: '100k', max: TOP_100K, label: 'Top 100k' },
];

const tierFor = (rank) =>
	typeof rank === 'number' && rank > 0
		? TIERS.find((tier) => rank <= tier.max) ?? null
		: null;

/*
 * Replaces manager.html:112-125. Three columns fit a phone, so this stays
 * a table; the wide tables elsewhere in the app are the ones that need a
 * card treatment.
 */
export default function SeasonHistory({ seasons }) {
	if (!seasons?.length) return null;

	return (
		<section className="season-history">
			<h2 className="section-title">Season history</h2>
			<div className="scroll-x">
				<table className="table">
					<thead>
						<tr>
							<th scope="col">Season</th>
							<th scope="col" className="table__num">
								Points
							</th>
							<th scope="col" className="table__num">
								Rank
							</th>
							{/* Badges get their own column so they line up regardless of
							    how many digits the rank has. */}
							<th scope="col" className="table__badge">
								<span className="visually-hidden">Finish</span>
							</th>
						</tr>
					</thead>
					<tbody>
						{seasons.map((season) => {
							const tier = tierFor(season.rank);
							return (
								<tr key={season.season_name} data-tier={tier?.id}>
									<th scope="row">{season.season_name}</th>
									<td className="table__num numeric">
										{nf.format(season.total_points)}
									</td>
									<td className="table__num numeric">{nf.format(season.rank)}</td>
									<td className="table__badge">
										{tier && (
											<span
												className={`badge badge--${tier.id}`}
												title={`${tier.label} finish`}
											>
												{tier.label}
											</span>
										)}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</section>
	);
}
